/**
 *
 * LandingPageBackgroundSelector
 *
 */

import React from 'react'
import { Global, css } from '@emotion/react'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { gql } from '@apollo/client'

import ImagePreview from 'components/ImagePreview'
import MultiSelect from 'components/MultiSelect'
import Checkbox from 'components/Checkbox'
import Spinner from 'components/Spinner'
import ApolloClient from '../ApolloClient'

const styles = css`
	#landing_page_background_selector {
		padding-top: 5px;
		overflow: auto;

		input[type='radio'] {
			display: block;
			margin: 0.5em auto;
		}

		.image-container {
			width: 120px;
			margin: 5px;
			position: relative;
		}

		label {
			width: 100%;
			height: 75px;
		}

		label.selected {
			outline: 4px solid #16a1d4; /*bootstrap primary color*/
		}

		.use_default_message {
			width: 100%;
			height: 100%;
			color: #bbb;
			font-weight: bold;
			padding: 0 5px;
			text-align: center;
			border: 1px solid #bbb;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
`

class LandingPageBackgroundSelector extends React.Component {
	// eslint-disable-line react/prefer-stateless-function

	constructor(props) {
		super(props)
		this.state = {
			backgrounds: [],
			all_tags: [],
			filter_tags: [],
			match_all: false,
			loading: false,
		}
		this.client = new ApolloClient()
	}

	loadTags = () => {
		const GET_LANDING_PAGE_BACKGROUND_TAGS = gql`
			{
				landing_page_background_tags
			}
		`

		this.client.query({ query: GET_LANDING_PAGE_BACKGROUND_TAGS }).then((r) => {
			if (r.data?.landing_page_background_tags) {
				this.setState({ all_tags: r.data.landing_page_background_tags })
			}
		})
	}

	loadBackgrounds = ({ tags, match }) => {
		const GET_BACKGROUNDS = gql`
			query GetBackgrounds($tags: [String!], $match: String) {
				landing_page_backgrounds(tags: $tags, match: $match) {
					id
					name
					image_url
					thumbnail_url
				}
			}
		`

		this.setState({ loading: true })
		this.client.query({ query: GET_BACKGROUNDS, variables: { tags, match } }).then((r) => {
			if (r.data) {
				this.setState({ backgrounds: r.data.landing_page_backgrounds })
			}
		}).finally(() => this.setState({ loading: false }))
	}

	componentDidMount() {
		this.loadTags()
		this.loadBackgrounds({ tags: null, match: null })
	}

	render() {
		return (
			<React.Fragment>
				<Global styles={styles} />
				<div id="landing_page_background_selector">
					<div className="form-text text-muted mb-2">Landing Page Background Image</div>

					{this.state.all_tags.length > 0 && (
						<div className="mb-3" style={{ maxWidth: 600 }}>
							<div className="d-flex align-items-center">
								<div className="flex-grow-1 mr-2">
									<MultiSelect
										options={this.state.all_tags.map((t) => ({ label: t, value: t }))}
										value={this.state.filter_tags}
										onChange={(arr) => this.setState({ filter_tags: arr })}
										placeholder="Filter by tags"
										show_values={false}
										class_name="w-100"
									/>
								</div>
								<div className="d-flex align-items-center mr-3">
									<Checkbox
										name="match_all"
										checked={this.state.match_all}
										onChange={(checked) => this.setState({ match_all: checked })}
										label="Require all selected tags"
										style={{ alignItems: 'center', margin: 0, whiteSpace: 'nowrap' }}
									/>
								</div>
								<div className="d-flex flex-column">
									<button
										type="button"
										className="btn btn-primary"
										onClick={() =>
											this.loadBackgrounds({
												tags: this.state.filter_tags.length ? this.state.filter_tags : null,
												match: this.state.filter_tags.length ? (this.state.match_all ? 'all' : 'any') : null,
											})
										}
									>
										Search
									</button>
								</div>
							</div>
						</div>
					)}

					<div className="d-flex flex-wrap">
						<div className="image-container">
							<label
								htmlFor="default"
								className={this.props.current_background_id === '' ? 'selected' : ''}
							>
								<div className="use_default_message">
									<span>Use Default Image</span>
								</div>
							</label>
							<input
								id="default"
								type="radio"
								name="landing_page_background_id"
								value=""
								onChange={this.props.handleInputChange}
								checked={this.props.current_background_id === ''}
								disabled={this.props.disabled}
							/>
						</div>
						{this.state.loading && (
							<div className="w-100 d-flex justify-content-center align-items-center pb-4">
								<Spinner />
							</div>
						)}
						{!this.state.loading &&
							this.state.backgrounds?.map((background) => (
								<div key={background.id} className="image-container">
									<label
										htmlFor={background.id}
										className={this.props.current_background_id === background.id ? 'selected' : ''}
									>
										<ImagePreview src={background.image_url} thumbnail_src={background.thumbnail_url} alt={background.name} />
									</label>
									<input
										id={background.id}
										type="radio"
										name="landing_page_background_id"
										value={background.id}
										onChange={this.props.handleInputChange}
										checked={this.props.current_background_id === background.id}
										disabled={this.props.disabled}
									/>
								</div>
							))}
					</div>
				</div>
			</React.Fragment>
		)
	}
}

LandingPageBackgroundSelector.propTypes = {}

export default LandingPageBackgroundSelector
